import { IJKSchema } from '../../../../repositories/monolith-python/entities/offer/JKSchema';
import { IJK } from '../../../../redux/reducers';

export const mapJK = (jk: IJK | null | undefined): IJKSchema | null => {
  if (!jk) {
    return null;
  }

  let { developer } = jk;

  if (developer && !developer.name && !developer.id) {
    developer = null;
  }

  if (!jk.name && !jk.id && !developer) {
    return null;
  }

  return {
    ...jk,
    developer,
  };
};
